import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
    setYearBounds,
    setYears,
    changeCompareYear,
    changeSampleYear,
    changeYearBounds,
    addOpenRow,
    removeOpenRows,
    setOpenRows,
} from './actions'

function mapStateToProps(state, hocProps) {
    return {
        compareYear: state.getIn(['financeTable', hocProps.id, hocProps.tableType, 'compareYear']),
        lowerBound: state.getIn(['financeTable', hocProps.id, hocProps.tableType, 'lowerBound']),
        sampleYear: state.getIn(['financeTable', hocProps.id, hocProps.tableType, 'sampleYear']),
        upperBound: state.getIn(['financeTable', hocProps.id, hocProps.tableType, 'upperBound']),
        openRows: state.getIn(['financeTable', hocProps.id, hocProps.tableType, 'openRows'], []),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            setYears,
            setYearBounds,
            changeCompareYear,
            changeSampleYear,
            changeYearBounds,
            addOpenRow,
            removeOpenRows,
            setOpenRows,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
